<div class="light party-sheet-dialog">
  <div class="scroll-container" [ngClass]="{ denied: gameManager.stateManager.permissions && !gameManager.stateManager.permissions.party }">
    <div
      class="container"
      [ngClass]="{ 'fh-container': !campaign && fhSheet, 'gh2e-container': !campaign && gh2eSheet, 'campaign-container': campaign }"
    >
      @if (!campaign && !fhSheet && !gh2eSheet) {
        <div class="sheet" [ngClass]="{ 'fh-sheet': fhSheet }">
          <div class="columns">
            <div class="column column-left">
              <div class="row title">
                <span class="campaign-toggle ignore-denied" (click)="campaign = true">
                  <img src="./assets/images/left.svg" /><span [ghs-label]="'party.campaign'"></span>
                </span>
                <label class="headline"><span [ghs-label]="'party.sheet'"></span> </label>
                @if (gameManager.game.parties.length > 1 && !gameManager.game.scenario) {
                  <select class="select-party" (change)="selectParty($event)" [ghs-label]="'party.change'" [ghs-label-attribute]="'title'">
                    @for (p of gameManager.game.parties | trackUUID; track p._trackUUID) {
                      <option [selected]="p.id === party.id" [disabled]="p.id === party.id" value="{{ p.id }}">
                        @if (p.name) {
                          <span>{{ p.name }}</span>
                        }
                        @if (!p.name) {
                          <span><span [ghs-label]="'party.campaign'"></span>&nbsp;{{ p.id }}</span>
                        }
                      </option>
                    }
                  </select>
                }
                <span class="spacer"></span>
                @if (!disableShortcuts) {
                  <span class="map ignore-denied">
                    <img (click)="openFlowChart()" src="./assets/images/chart.svg" [ghs-tooltip]="'scenario.chart'" />
                    @if (worldMap) {
                      <img (click)="openMap()" src="./assets/images/map.svg" [ghs-tooltip]="'party.campaign.map'" />
                    }
                  </span>
                }
              </div>
              <div class="row name">
                <label><span [ghs-label]="'party.name'"></span>:</label>
                <input
                  type="text"
                  [value]="party.name"
                  (change)="setName($event)"
                  [ghs-label]="'party.name'"
                  [ghs-label-attribute]="'placeholder'"
                />
                @if (!gameManager.game.scenario) {
                  @if (gameManager.game.parties.length > 1) {
                    <img
                      class="remove-party"
                      src="./assets/images/minus.svg"
                      (click)="removeParty()"
                      [ghs-label]="'party.remove'"
                      [ghs-label-attribute]="'title'"
                    />
                  }
                  <span class="spacer"></span>
                  <img
                    class="new-party"
                    src="./assets/images/plus.svg"
                    (click)="newParty()"
                    [ghs-label]="'party.new'"
                    [ghs-label-attribute]="'title'"
                  />
                }
                @if (!!gameManager.game.scenario) {
                  <div class="hint-container new-party-hint">
                    <img src="./assets/images/plus.svg" class="hint-trigger ghs-svg" />
                    <span class="hint">
                      <span class="text"><span [ghs-label]="'party.new.hint'"></span></span>
                    </span>
                  </div>
                }
              </div>
              <div class="row location">
                <label><span [ghs-label]="'party.location'"></span>:</label>
                <input
                  type="text"
                  [value]="party.location"
                  (change)="setLocation($event)"
                  [ghs-label]="'party.location'"
                  [ghs-label-attribute]="'placeholder'"
                />
              </div>
              <div class="row notes">
                <label><span [ghs-label]="'party.notes'"></span>:</label>
                <textarea
                  type="text"
                  [value]="party.notes"
                  (change)="setNotes($event)"
                  [ghs-label]="'party.notes'"
                  [ghs-label-attribute]="'placeholder'"
                ></textarea>
              </div>
              <div class="row achievements">
                <label><span [ghs-label]="'party.achievements'"></span>:</label>
                <div class="achievements-container">
                  <div class="list">
                    @for (achievement of partyAchievementsList; track achievement; let i = $index) {
                      <div class="achievement">
                        @if (achievement.split(':').length > 0 && achievement.split(':')[1] !== '1') {
                          <span> {{ achievement.split(':')[1] }}x&nbsp; </span>
                        }
                        <span [ghs-label]="'data.partyAchievements.' + achievement.split(':')[0]"></span>
                        <span class="spacer"></span>
                        <span class="remove" (click)="removeAchievement(achievement)">
                          <img class="ghs-svg" src="./assets/images/close.svg"
                        /></span>
                      </div>
                    }
                  </div>
                  <div class="form">
                    <input
                      type="text"
                      #partyAchievementInput
                      [autocomplete]="partyAchievements"
                      [spoiler]="true"
                      [emptyLabel]="'party.addPartyAchievement.empty'"
                      [ghs-label]="'party.addPartyAchievement'"
                      [ghs-label-attribute]="'placeholder'"
                      (keyup.enter)="addAchievement(partyAchievementInput)"
                    />
                    <a
                      class="addScenario"
                      [ghs-label]="'party.addPartyAchievement'"
                      [ghs-label-attribute]="'title'"
                      (click)="addAchievement(partyAchievementInput)"
                      ><img src="./assets/images/plus.svg"
                    /></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="column column-right">
              <div class="columns">
                <div class="column reputation">
                  <label><span [ghs-label]="'party.reputation'"></span></label>
                  <div class="grid">
                    @for (reputation of [] | ghsRange: 41; track reputation) {
                      <span
                        class="value"
                        (click)="setReputation(40 - reputation - 20)"
                        [ngClass]="{ checked: party.reputation === 40 - reputation - 20 }"
                      ></span>
                      <span class="key">{{ 40 - reputation - 20 | ghsValueSign }}</span>
                    }
                  </div>
                </div>
                <div class="column shop">
                  <label><span [ghs-label]="'party.shop'"></span></label>
                  <div class="table">
                    @for (value of [] | ghsRange: 11; track value) {
                      <div class="value" [ngClass]="{ active: priceModifier === -5 + value }">
                        @if (value !== 5) {
                          <span>{{ -5 + value | ghsValueSign }}</span>
                        }
                        @if (value === 5) {
                          <span><span [ghs-label]="'party.shop.none'"></span></span>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="import-export">
                <label class="export" (click)="exportParty()" [ghs-label]="'party.export'" [ghs-label-attribute]="'title'">
                  <img src="./assets/images/export.svg" />
                  <span><span [ghs-label]="'party.export'"></span></span>
                </label>
                <label class="import" [ghs-label]="'party.import'" [ghs-label-attribute]="'title'" (click)="ghsInputFullScreenCheck()">
                  <input type="file" accept="application/json" (change)="importParty($event)" />
                  <img src="./assets/images/import.svg" />
                  <span><span [ghs-label]="'party.import'"></span></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      }

      <!-- FH SHEET -->
      @if (!campaign && fhSheet) {
        <div class="sheet fh-sheet">
          <div class="title">
            <label class="summer" [ngClass]="{ highlight: summer }"
              ><img src="./assets/images/fh/party/summer.svg" />
              <span [ghs-label]="'party.campaign.sheet.summer'"></span>
            </label>
            <label class="headline ignore-denied" (click)="campaign = true">
              <span [ghs-label]="'party.campaign.sheet'"></span>
              <span class="management">
                <img src="./assets/images/left.svg" />
                <span [ghs-label]="'party.campaign.manage'"></span>
              </span>
            </label>
            <label class="winter" [ngClass]="{ highlight: !summer }"
              ><span [ghs-label]="'party.campaign.sheet.winter'"></span><img src="./assets/images/fh/party/winter.svg"
            /></label>
          </div>
          <div
            class="calendar-lock-toggle"
            [ghs-tooltip]="'party.campaign.sheet.weekSections.lock'"
            [ngClass]="{ permissive: settingsManager.settings.calendarLocked === 'permissive' }"
          >
            <a
              ghs-pointer-input
              (singleClick)="settingsManager.toggle('calendarLocked')"
              (doubleClick)="
                settingsManager.set('calendarLocked', settingsManager.settings.calendarLocked !== 'permissive' ? 'permissive' : true)
              "
            >
              <img [src]="'./assets/images/lock' + (settingsManager.settings.calendarLocked ? '' : '-open') + '.svg'" />
            </a>
          </div>
          @if (!disableShortcuts) {
            <span class="map ignore-denied">
              <img (click)="openFlowChart()" src="./assets/images/chart.svg" [ghs-tooltip]="'scenario.chart'" />
              @if (worldMap) {
                <img (click)="openMap()" src="./assets/images/map.svg" [ghs-tooltip]="'party.campaign.map'" />
              }
            </span>
          }
          @if (party.weeks === 80 + 80 * calendarSheet) {
            <span class="next" (click)="setWeek(party.weeks + 1)"
              ><span [ghs-label]="'party.campaign.sheet.nextWeek'"></span> <img src="./assets/images/right.svg"
            /></span>
          }
          <div class="weeks">
            @for (week of [] | ghsRange: 80; track week; let index = $index) {
              <div
                class="week"
                ghs-pointer-input
                [ghs-tooltip]="'party.campaign.sheet.weekSections.hint'"
                (singleClick)="setWeek(index + 1 + 80 * calendarSheet)"
                (doubleClick)="setWeekSection(index + 1 + 80 * calendarSheet)"
                [ngClass]="{
                  checked: party.weeks > index + 80 * calendarSheet,
                  section:
                    sectionsForWeekFixed(week + 80 * calendarSheet).length > 0 || sectionsForWeek(week + 80 * calendarSheet).length > 0,
                  locked:
                    settingsManager.settings.calendarLocked &&
                    (settingsManager.settings.calendarLocked !== 'permissive' ||
                      (party.weeks !== index + 80 * calendarSheet && party.weeks !== index + 80 * calendarSheet + 1))
                }"
              >
                @for (section of sectionsForWeekFixed(week + 80 * calendarSheet); track section + $index) {
                  <div class="section">
                    <img
                      [src]="
                        './assets/images/' +
                        (hasConclusions(section) ? 'hint.svg' : isConclusion(section) ? 'scenario/conclusion.svg' : 'fh/party/section.svg')
                      "
                    />
                    {{ section }}
                  </div>
                }
                @for (section of sectionsForWeek(week + 80 * calendarSheet); track section + $index) {
                  <div class="section manual">
                    <img
                      [src]="
                        './assets/images/' +
                        (hasConclusions(section) ? 'hint.svg' : isConclusion(section) ? 'scenario/conclusion.svg' : 'fh/party/section.svg')
                      "
                    />
                    {{ section }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="name">
            <label><span [ghs-label]="'party.campaign.sheet.name'"></span></label>
            <input
              type="text"
              [value]="party.name"
              (change)="setName($event)"
              [ghs-label]="'party.campaign.sheet.name'"
              [ghs-label-attribute]="'placeholder'"
            />
            @if (!gameManager.game.scenario) {
              @if (gameManager.game.parties.length > 1) {
                <img
                  class="remove-party"
                  src="./assets/images/minus.svg"
                  (click)="removeParty()"
                  [ghs-label]="'party.remove'"
                  [ghs-label-attribute]="'title'"
                />
              }
              @if (gameManager.game.parties.length > 1 && !gameManager.game.scenario) {
                <select class="select-party" (change)="selectParty($event)" [ghs-label]="'party.change'" [ghs-label-attribute]="'title'">
                  @for (p of gameManager.game.parties | trackUUID; track p._trackUUID) {
                    <option [selected]="p.id === party.id" [disabled]="p.id === party.id" value="{{ p.id }}">
                      @if (p.name) {
                        <span>{{ p.name }}</span>
                      }
                      @if (!p.name) {
                        <span><span [ghs-label]="'party.campaign'"></span>&nbsp;{{ p.id }}</span>
                      }
                    </option>
                  }
                </select>
              }
              <img
                class="new-party"
                src="./assets/images/plus.svg"
                (click)="newParty()"
                [ghs-label]="'party.new'"
                [ghs-label-attribute]="'title'"
              />
            }
            @if (!!gameManager.game.scenario) {
              <div class="hint-container new-party-hint">
                <img src="./assets/images/plus.svg" class="hint-trigger ghs-svg" />
                <span class="hint">
                  <span class="text"><span [ghs-label]="'party.new.hint'"></span></span>
                </span>
              </div>
            }
          </div>
          <div class="resources">
            <div class="header">
              <label class="supply" (click)="openResources()"><span [ghs-label]="'party.campaign.sheet.supply'"></span>:</label>
              <span class="spacer"></span>
              @if (characters.length > 0 && !settingsManager.settings.fhShareResources) {
                <div class="move-resources">
                  <span class="label"><span [ghs-label]="'character.progress.resources.move'"></span>:</span>
                  <div class="characters">
                    @for (character of characters | trackUUID; track character._trackUUID) {
                      <span class="character" (click)="moveResources(character)"><img [src]="character.iconUrl" /></span>
                    }
                  </div>
                </div>
              }
            </div>
            <div class="resource-table">
              <div class="materials">
                @for (resource of materialResourceLootTypes; track resource) {
                  <div class="resource {{ resource }}" [ghs-tooltip]="'game.loot.' + resource">
                    <img [src]="'./assets/images/fh/loot/' + resource + '.svg'" />
                    <input [value]="party.loot[resource] || 0" type="number" min="0" (change)="setResource(resource, $event)" />
                  </div>
                }
              </div>
              <div class="herbs">
                @for (resource of herbResourceLootTypes; track resource) {
                  <div class="resource {{ resource }}" [ghs-tooltip]="'game.loot.' + resource">
                    <img [src]="'./assets/images/fh/loot/' + resource + '.svg'" />
                    <input [value]="party.loot[resource] || 0" type="number" min="0" (change)="setResource(resource, $event)" />
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="inspiration">
            <label><span [ghs-label]="'party.inspiration'"></span>:</label>
            <input
              type="number"
              [value]="party.inspiration || 0"
              (change)="setInspiration($event)"
              [ghs-label]="'party.inspiration'"
              [ghs-label-attribute]="'placeholder'"
            />
          </div>
          <div class="total-defense">
            <label><span [ghs-label]="'party.campaign.sheet.totalDefense'"></span>:</label>
            <input
              type="number"
              [value]="(party.defense || 0) + moraleDefense"
              (change)="setTotalDefense($event)"
              [ghs-label]="'party.campaign.sheet.totalDefense'"
              [ghs-label-attribute]="'placeholder'"
            />
          </div>
          <div class="soldiers">
            <label><span [ghs-label]="'party.campaign.sheet.soldiers'"></span>:</label>
            <div class="soldier-table">
              @for (level of [] | ghsRange: 4; track level) {
                <div class="line">
                  <label>
                    <span class="text">
                      <span [ghs-label]="'party.campaign.sheet.soldierLevel'"></span>
                    </span>
                    <span>{{ level + 1 }}</span>
                  </label>
                  <div class="soldiers-line">
                    @for (soldier of [] | ghsRange: (level > 0 ? 2 : 4); track soldier) {
                      <div
                        class="soldier"
                        ghs-pointer-input
                        (singleClick)="setSoldiers(soldier + (level > 0 ? 2 + level * 2 : 0) + 1)"
                        (doubleClick)="setSoldiers(soldier + (level > 0 ? 2 + level * 2 : 0) + 1, true)"
                        [ngClass]="{ disabled: soldier + (level > 0 ? 2 + level * 2 : 0) >= party.soldiers + (soldierAvailable() ? 1 : 0) }"
                      >
                        <img src="./assets/images/fh/party/soldier.svg" />
                        <div class="check" [ngClass]="{ checked: soldier + (level > 0 ? 2 + level * 2 : 0) < party.soldiers }"></div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="morale">
            <label><span [ghs-label]="'party.morale'"></span></label>
            <div class="grid morale-grid">
              @for (morale of [] | ghsRange: 21; track morale) {
                <span class="value" (click)="setMorale(20 - morale)" [ngClass]="{ checked: party.morale === 20 - morale }">
                  <span class="key">{{ 20 - morale }}</span>
                </span>
              }
            </div>
          </div>
          <div class="defense">
            <label><span [ghs-label]="'party.campaign.sheet.defense'"></span></label>
            <div class="grid defense-grid">
              <span class="sections" [ngClass]="{ highlight: party.morale > 19 }">
                @for (
                  conclusion of gameManager.campaignData().highMorale || [] | slice: 0 : highMoraleSolved + 1;
                  track conclusion;
                  let i = $index
                ) {
                  <span class="section" [ngClass]="{ conclusion: isConclusion(gameManager.campaignData().highMorale[i]) }">
                    <img src="./assets/images/fh/party/section.svg" />
                    {{ gameManager.campaignData().highMorale[i] || '' }}
                  </span>
                }
              </span>
              <span class="value" [ngClass]="{ highlight: moraleDefense === 15 }">+15</span>
              <span class="value" [ngClass]="{ highlight: moraleDefense === 10 }">+10</span>
              <span class="value" [ngClass]="{ highlight: moraleDefense === 5 }">+5</span>
              <span class="value" [ngClass]="{ highlight: moraleDefense === 0 }">0</span>
              <span class="value" [ngClass]="{ highlight: moraleDefense === -5 }">-5</span>
              <span class="value" [ngClass]="{ highlight: moraleDefense === -10 }">-10</span>
              <span class="sections" [ngClass]="{ highlight: party.morale < 1 }">
                @for (
                  conclusion of gameManager.campaignData().lowMorale || [] | slice: 0 : lowMoraleSolved + 1;
                  track conclusion;
                  let i = $index
                ) {
                  <span class="section" [ngClass]="{ conclusion: isConclusion(gameManager.campaignData().lowMorale[i]) }">
                    <img src="./assets/images/fh/party/section.svg" />
                    {{ gameManager.campaignData().lowMorale[i] || '' }}
                  </span>
                }
              </span>
            </div>
          </div>
          <div class="town-guard-perks">
            <label><span [ghs-label]="'party.campaign.sheet.townGuardPerks'"></span></label>
            <div class="town-guard-perks-grid">
              @for (item of [] | ghsRange: 45; track item) {
                @if (item % 3 === 0) {
                  <span class="checkmark"> <img src="./assets/images/close.svg" />:</span>
                }
                <span
                  class="townguard-perk checkbox"
                  [ngClass]="{ checked: party.townGuardPerks >= item + 1 }"
                  (click)="setTownGuardPerks(item + 1)"
                ></span>
              }
            </div>
            <div class="perk-list">
              @for (townGuardPerk of gameManager.campaignData().townGuardPerks | trackUUID; track townGuardPerk._trackUUID) {
                <div class="perk">
                  <div class="sections">
                    @for (section of townGuardPerk.sections; track section + $index) {
                      <div
                        class="section"
                        [ngClass]="{
                          checked: party.townGuardPerkSections.includes(section),
                          disabled:
                            !party.townGuardPerkSections.includes(section) &&
                            party.townGuardPerkSections.length >= (party.townGuardPerks / 3 | ghsFloor)
                        }"
                        ghs-pointer-input
                        (singleClick)="toggleTownGuardPerkSection(section)"
                        (doubleClick)="toggleTownGuardPerkSection(section, true)"
                      >
                        <img src="./assets/images/fh/party/section.svg" /> {{ section }}
                      </div>
                    }
                  </div>
                  <ghs-perk-label [perk]="townGuardPerk.perk"></ghs-perk-label>
                </div>
              }
            </div>
            @if (party.townGuardPerkSections.length > (party.townGuardPerks / 3 | ghsFloor)) {
              <div class="warning" [ghs-label]="'game.attackModifiers.perks.warning'" [ghs-label-attribute]="'title'">
                <img class="ghs-svg" src="./assets/images/warning.svg" />
                <span [ghs-label]="'game.attackModifiers.perks.warning'"></span>
              </div>
            }
          </div>
          <div class="campaign-stickers">
            <div class="header">
              <label><span [ghs-label]="'party.campaign.sheet.campaignStickers'"></span></label>
              <input
                type="text"
                #campaignStickerEl
                [autocomplete]="campaignStickers"
                [emptyLabel]="'party.campaign.sheet.campaignStickers.empty'"
                [ghs-label]="'party.campaign.sheet.campaignStickers'"
                [ghs-label-attribute]="'placeholder'"
                (keyup.enter)="addCampaignSticker(campaignStickerEl)"
              />
              <img src="./assets/images/plus.svg" (click)="addCampaignSticker(campaignStickerEl)" />
            </div>
            <div
              class="stickers ignore-denied"
              [ngClass]="{ denied: gameManager.stateManager.permissions && !gameManager.stateManager.permissions.party }"
            >
              @for (sticker of party.campaignStickers; track sticker + $index; let index = $index) {
                <div class="sticker">
                  @if (!campaignStickerImage(sticker, index)) {
                    <span class="text" [ghs-label]="'data.campaignSticker.' + sticker"></span>
                  }
                  @if (campaignStickerImage(sticker, index)) {
                    <img class="image" [src]="campaignStickerImage(sticker, index)" [ghs-tooltip]="'data.campaignSticker.' + sticker" />
                  }
                  <img class="remove" src="./assets/images/minus.svg" (click)="removeCampaignSticker(sticker)" />
                </div>
              }
            </div>
          </div>
          <ghs-party-buildings [party]="party"></ghs-party-buildings>
          @if (!!townGuardDeck && townGuardDeck.cards.length > 0) {
            <div class="town-guard-deck-container" [ngClass]="{ active: townGuardDeck.active }">
              <div class="town-guard-deck" [ngClass]="{ collapsed: !townGuardDeck.active, full: townGuardDeck.active }">
                <ghs-attackmodifier-deck
                  [deck]="townGuardDeck"
                  [townGuard]="true"
                  (before)="beforeTownGuardDeck($event)"
                  (after)="afterTownGuardDeck($event)"
                ></ghs-attackmodifier-deck>
                <div class="active-toggle" (click)="toggleTownGuardDeck()">
                  <span class="numeration"></span>
                </div>
              </div>
            </div>
          }
        </div>
      }

      <!-- GH2E SHEET -->
      @if (!campaign && gh2eSheet) {
        <div class="sheet gh2e-sheet">
          <div class="title">
            <label class="headline ignore-denied" (click)="campaign = true">
              <span [ghs-label]="'party.campaign.sheet'"></span>
              <span class="management">
                <img src="./assets/images/left.svg" />
                <span [ghs-label]="'party.campaign.manage'"></span>
              </span>
            </label>
          </div>
          <div class="name">
            <label><span [ghs-label]="'party.campaign.sheet.name'"></span></label>
            <input
              type="text"
              [value]="party.name"
              (change)="setName($event)"
              [ghs-label]="'party.campaign.sheet.name'"
              [ghs-label-attribute]="'placeholder'"
            />
            @if (!gameManager.game.scenario) {
              @if (gameManager.game.parties.length > 1) {
                <img
                  class="remove-party"
                  src="./assets/images/minus.svg"
                  (click)="removeParty()"
                  [ghs-label]="'party.remove'"
                  [ghs-label-attribute]="'title'"
                />
              }
              @if (gameManager.game.parties.length > 1 && !gameManager.game.scenario) {
                <select class="select-party" (change)="selectParty($event)" [ghs-label]="'party.change'" [ghs-label-attribute]="'title'">
                  @for (p of gameManager.game.parties | trackUUID; track p._trackUUID) {
                    <option [selected]="p.id === party.id" [disabled]="p.id === party.id" value="{{ p.id }}">
                      @if (p.name) {
                        <span>{{ p.name }}</span>
                      }
                      @if (!p.name) {
                        <span><span [ghs-label]="'party.campaign'"></span>&nbsp;{{ p.id }}</span>
                      }
                    </option>
                  }
                </select>
              }
              <img
                class="new-party"
                src="./assets/images/plus.svg"
                (click)="newParty()"
                [ghs-label]="'party.new'"
                [ghs-label-attribute]="'title'"
              />
            }
            @if (!!gameManager.game.scenario) {
              <div class="hint-container new-party-hint">
                <img src="./assets/images/plus.svg" class="hint-trigger ghs-svg" />
                <span class="hint">
                  <span class="text"><span [ghs-label]="'party.new.hint'"></span></span>
                </span>
              </div>
            }
          </div>
          <div class="inspiration">
            <label><span [ghs-label]="'party.inspiration'"></span>:</label>
            <input
              type="number"
              [value]="party.inspiration || 0"
              (change)="setInspiration($event)"
              [ghs-label]="'party.inspiration'"
              [ghs-label-attribute]="'placeholder'"
            />
          </div>
          <div class="factions">
            @for (faction of factions; track faction) {
              <div class="faction-reputation">
                <label>
                  <img [src]="'./assets/images/gh2e/faction/' + faction + '.svg'" />
                  <span [ghs-label]="'party.reputation'"></span>
                </label>
                <div class="grid">
                  @for (reputation of [] | ghsRange: 31; track reputation) {
                    <div class="row" [ngClass]="{ locked: 30 - reputation - 10 > 12 && !factionUnlocks.includes(faction) }">
                      <span
                        class="value"
                        ghs-pointer-input
                        (singleClick)="setFactionReputation(faction, 30 - reputation - 10)"
                        [ngClass]="{ checked: party.factionReputation[faction] === 30 - reputation - 10 }"
                        (doubleClick)="setFactionReputation(faction, 30 - reputation - 10, true)"
                      ></span>
                      <span
                        class="key"
                        ghs-pointer-input
                        (singleClick)="setFactionReputation(faction, 30 - reputation - 10)"
                        (doubleClick)="setFactionReputation(faction, 30 - reputation - 10, true)"
                        >{{ 30 - reputation - 10 }}</span
                      >
                      <span class="section">
                        @if (reputationSectionsMapped[faction] && reputationSectionsMapped[faction][reputation]) {
                          <span
                            class="checkbox"
                            [ngClass]="{ checked: isConclusion(reputationSectionsMapped[faction][reputation].section) }"
                          ></span>
                          <span
                            class="text"
                            ghs-pointer-input
                            (singleClick)="
                              unlockConclusion(
                                reputationSectionsMapped[faction][reputation].section,
                                (party.factionReputation[faction] || 0) >= 30 - reputation - 10
                              )
                            "
                            (doubleClick)="
                              unlockConclusion(
                                reputationSectionsMapped[faction][reputation].section,
                                (party.factionReputation[faction] || 0) >= 30 - reputation - 10,
                                true
                              )
                            "
                            [ghs-label]="'%game.section:' + reputationSectionsMapped[faction][reputation].section + '%'"
                          ></span>
                        }
                      </span>
                    </div>
                  }
                </div>
                <span class="checkbox limit" [ngClass]="{ checked: (party.factionReputation[faction] || 0) > 12 }"></span>
              </div>
            }
          </div>
          <div class="additional-factions">
            <label><span [ghs-label]="'party.reputation.additional'"></span></label>
            <div class="faction-reputation">
              @for (reputationSection of reputationSections | trackUUID; track reputationSection._trackUUID) {
                @if (reputationSection.faction === 'special') {
                  <div class="section">
                    <span
                      class="checkbox"
                      [ngClass]="{ checked: isConclusion(reputationSection.section) || additionalReputation(reputationSection) }"
                    ></span>
                    <span
                      class="text"
                      [ghs-label]="'party.reputation.additional.special.' + reputationSection.section.split(':')[0]"
                      [ghs-label-args]="[reputationSection.section.split(':')[1], reputationSection.value]"
                    ></span>
                  </div>
                }
              }
            </div>
            @for (faction of factions; track faction) {
              <div class="faction-reputation">
                <div class="header">
                  <img [src]="'./assets/images/gh2e/faction/' + faction + '.svg'" />
                </div>
                @for (reputationSection of reputationSections | trackUUID; track reputationSection._trackUUID) {
                  @if (reputationSection.faction === faction && reputationSection.requires && reputationSection.requires.length) {
                    <div class="section">
                      <span
                        class="checkbox"
                        [ngClass]="{ checked: isConclusion(reputationSection.section) || additionalReputation(reputationSection) }"
                      ></span>
                      <span
                        class="text"
                        ghs-pointer-input
                        (singleClick)="unlockConclusion(reputationSection.section, additionalReputation(reputationSection))"
                        (doubleClick)="unlockConclusion(reputationSection.section, additionalReputation(reputationSection), true)"
                        [ghs-label]="
                          'party.reputation.additional.sectionRequires' + (reputationSection.requires.length > 1 ? '.multiple' : '')
                        "
                        [ghs-label-args]="[
                          reputationSection.section,
                          reputationSection.value,
                          reputationSection.faction,
                          reputationSection.requires.join(' & ')
                        ]"
                      ></span>
                    </div>
                  }
                }
              </div>
            }
          </div>
          <div class="row notes">
            <label><span [ghs-label]="'party.notes'"></span>:</label>
            <textarea
              type="text"
              [value]="party.notes"
              (change)="setNotes($event)"
              [ghs-label]="'party.notes'"
              [ghs-label-attribute]="'placeholder'"
            ></textarea>
          </div>
          <div class="imbuement">
            <label><span [ghs-label]="'party.imbuement'"></span></label>
            @for (row of [] | ghsRange: 8; track row) {
              <div class="checklist-container">
                <div class="checklist">
                  @for (check of [] | ghsRange: 10; track check) {
                    <div
                      class="tick"
                      [ngClass]="{
                        section: check % 10 === 4 || imbuementSections[row * 10 + check + 1],
                        'prosperity-tick': check % 10 === 4
                      }"
                    >
                      <div class="checkbox" [ngClass]="{ checked: party.imbuement >= row * 10 + check + 1 }">
                        <span class="click" ghs-pointer-input (singleClick)="setImbuement(row * 10 + check + 1)"></span>
                        @if (check % 10 === 4) {
                          <span class="section"> +1 <img src="./assets/images/fh/prosperity.svg" /> </span>
                        }
                        @if (imbuementSections[row * 10 + check + 1]) {
                          <span
                            class="section"
                            ghs-pointer-input
                            (singleClick)="
                              unlockConclusion(imbuementSections[row * 10 + check + 1], party.imbuement >= row * 10 + check + 1)
                            "
                            (doubleClick)="
                              unlockConclusion(imbuementSections[row * 10 + check + 1], party.imbuement >= row * 10 + check + 1, true)
                            "
                            [ghs-label]="'%game.section:' + imbuementSections[row * 10 + check + 1] + '%'"
                          ></span>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          <div class="donations">
            <label><span [ghs-label]="'party.greatOak'"></span></label>
            @for (row of [] | ghsRange: 10; track row) {
              <div class="checklist-container">
                <div class="checklist">
                  @for (check of [] | ghsRange: 10; track check) {
                    <div class="tick" [ngClass]="{ section: check % 5 === 4, 'prosperity-tick': check % 5 === 4 }">
                      <div
                        class="checkbox"
                        (click)="setDonations(row * 10 + check + 1)"
                        [ngClass]="{ checked: party.donations >= row * 10 + check + 1 }"
                      >
                        @if (check % 5 === 4) {
                          <div class="section">+1 <img src="./assets/images/fh/prosperity.svg" /></div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          <div class="prosperity gh2e wrapped">
            <div class="checklist">
              <div class="legend">
                <span [ghs-label]="'party.prosperity'" [ghs-tooltip]="'party.prosperity.reset'" (click)="setProsperity(0)"></span>
                <img [ghs-tooltip]="'party.prosperity.reset'" src="./assets/images/fh/prosperity.svg" />
                <span>:</span>
              </div>
              <div class="tick large" [ghs-tooltip]="'party.prosperity.reset'" (click)="setProsperity(0)">
                <div class="level">1</div>
                <div class="checkbox checked disabled"></div>
              </div>
              @for (check of [] | ghsRange: prosperitySteps[prosperitySteps.length - 1] + 1; track check; let index = $index) {
                <div
                  class="tick"
                  [ngClass]="{ large: prosperitySteps.includes(index), section: prosperitySections[index], break: check === 33 }"
                >
                  @if (prosperitySteps.includes(index)) {
                    <div class="level" (click)="setProsperity(index + 1)">
                      {{ prosperitySteps.indexOf(index) + 2 }}
                    </div>
                  }
                  <div
                    class="checkbox"
                    [ngClass]="{
                      checked: gameManager.prosperityTicks() > index,
                      highlight: !prosperitySteps.includes(index) && prosperityHighlightSteps.includes(index)
                    }"
                  >
                    <span class="click" ghs-pointer-input (singleClick)="setProsperity(index + 1)"></span>
                    @if (prosperitySections[index]) {
                      <span
                        class="section"
                        ghs-pointer-input
                        (singleClick)="unlockConclusion(prosperitySections[index], gameManager.prosperityTicks() > index)"
                        (doubleClick)="unlockConclusion(prosperitySections[index], gameManager.prosperityTicks() > index, true)"
                        [ghs-label]="'%game.section:' + prosperitySections[index] + '%'"
                      ></span>
                    }
                  </div>
                </div>
                @if (check === 32) {
                  <div class="spacer"></div>
                }
              }
            </div>
          </div>
        </div>
      }

      @if (!campaign) {
        <div class="bottom-menu">
          @if (gh2eSheet) {
            <div
              class="retirement-note"
              ghs-pointer-input
              (singleClick)="isConclusion('68.4', 'gh2e') ? conclusionRewards('68.4') : finishConclusion('68.4')"
              (doubleClick)="removeConclusion('68.4', 'gh2e')"
            >
              <span class="checkbox" [ngClass]="{ checked: isConclusion('68.4', 'gh2e') }"></span>
              <span [ghs-label]="'data.section.rewards.gh2e.68-4.2'"></span>
            </div>
          }
          <span class="event-effects ignore-denied" (click)="openEventEffects()">
            <img class="ghs-svg" src="./assets/images/event.svg" /> <span [ghs-label]="'scenario.eventEffects'"></span>
          </span>
          <span class="toggle-fh-sheet ignore-denied" (click)="toggleFhSheet()">
            <span [ghs-label]="'party.campaign.sheet.' + (fhSheet ? 'disable' : 'enable')"></span>
          </span>
        </div>
      }

      <!-- CAMPAIGN -->
      @if (campaign) {
        <div class="campaign">
          <div class="row title">
            <span class="campaign-toggle ignore-denied" (click)="campaign = false">
              <img src="./assets/images/left.svg" /><span [ghs-label]="'party.sheet'"></span>
            </span>
            <label class="headline"><span [ghs-label]="'party.campaign'"></span></label>
            <span class="campaign-mode" (click)="toggleCampaignMode()">
              <span class="checkbox" [ngClass]="{ checked: party.campaignMode }"></span>
              <span [ghs-label]="'party.campaignMode'"></span>
            </span>
            @if (!disableShortcuts) {
              <span class="map ignore-denied">
                <img (click)="openFlowChart()" src="./assets/images/chart.svg" [ghs-tooltip]="'scenario.chart'" />
                @if (worldMap) {
                  <img (click)="openMap()" src="./assets/images/map.svg" [ghs-tooltip]="'party.campaign.map'" />
                }
              </span>
            }
          </div>
          <div class="row title">
            <label class="headline"><span [ghs-label]="'party.campaign.scenarios'"></span></label>
            <select (change)="changeEdition($event)">
              <option [value]="undefined" [selected]="!partyEdition"><span [ghs-label]="'edition.all'"></span></option>
              @for (ed of gameManager.editions(); track ed) {
                <option [selected]="ed === partyEdition" [value]="ed">
                  <span [ghs-label]="'data.edition.' + ed"></span>
                </option>
              }
            </select>
          </div>
          <div
            class="row scenarios ignore-denied"
            [ngClass]="{ denied: gameManager.stateManager.permissions && !gameManager.stateManager.permissions.party }"
          >
            <div class="scenario header legend seperator">
              <span><span [ghs-label]="'party.campaign.scenarios.index'"></span></span>
              <span><span [ghs-label]="'party.campaign.scenarios.group'"></span></span>
              <span><span [ghs-label]="'party.campaign.scenarios.name'"></span></span>
              <span><span [ghs-label]="'party.campaign.scenarios.finished'"></span></span>
            </div>
            @for (edition of scenarioEditions; track edition; let index = $index) {
              @if (index > 0) {
                <div class="scenario seperator"></div>
              }
              @if (scenarioEditions.length > 1) {
                <div class="scenario header">
                  <span class="span"><span [ghs-label]="'data.edition.' + edition"></span></span>
                </div>
              }
              @for (scenarioData of scenarios[edition] | trackUUID; track scenarioData._trackUUID) {
                <div class="scenario">
                  <span>
                    @if (!scenarioData.solo) {
                      #
                      @if (maxScenario(scenarios[edition]) > 2 && scenarioData.index.length < 3) {
                        <span>0</span>
                      }
                      @if (maxScenario(scenarios[edition]) > 1 && scenarioData.index.length < 2) {
                        <span>0</span>
                      }
                      {{ scenarioData.index }}
                    }
                    @if (scenarioData.solo) {
                      <img class="ghs-svg solo" [src]="characterIcon(scenarioData.solo)" />
                    }
                  </span>
                  <span>
                    @if (scenarioData.group) {
                      <span [ghs-label]="'data.scenario.group.' + scenarioData.group"></span>
                    }
                  </span>
                  <span
                    class="scenario-title"
                    [ngClass]="{ blocked: scenarioData.isBlocked, locked: !scenarioData.isBlocked && scenarioData.isLocked }"
                    [ghs-tooltip]="scenarioData.isBlocked ? 'scenario.blocked' : scenarioData.isLocked ? 'scenario.locked' : ''"
                    [toggable]="false"
                    (click)="scenarioRequirements(scenarioData)"
                  >
                    @if (scenarioData.isBlocked || scenarioData.isLocked) {
                      <img src="./assets/images/close.svg" />
                    }
                    <span
                      (click)="scenarioPopUp(scenarioData)"
                      [ghs-label]="gameManager.scenarioManager.scenarioTitle(scenarioData)"
                    ></span>
                  </span>
                  <span>
                    <span class="spacer"></span>
                    @if (isManual(scenarioData) && countFinished(scenarioData) < 1) {
                      <a
                        class="toggle-manual"
                        [ghs-label]="'party.campaign.scenarios.removeManual'"
                        [ghs-label-attribute]="'title'"
                        (click)="removeManual(scenarioData)"
                        ><img class="manual" src="./assets/images/hint.svg" /><img class="remove" src="./assets/images/close.svg"
                      /></a>
                    }
                    @if (scenarioData.isLocked) {
                      <span (click)="scenarioRequirements(scenarioData)" class="locked" [ghs-tooltip]="'scenario.locked'"
                        ><img class="ghs-svg" src="./assets/images/warning.svg"
                      /></span>
                    }
                    @if (hasRandomItemLooted(scenarioData)) {
                      <span class="rewards" [ghs-tooltip]="'scenario.summary.randomItemLooted'"
                        ><img class="ghs-svg" src="./assets/images/fh/loot/random_item.svg"
                      /></span>
                    }
                    @if (countFinished(scenarioData)) {
                      <span (click)="scenarioRewards(scenarioData)" class="rewards" [ghs-tooltip]="'scenario.summary.rewards'"
                        ><img class="ghs-svg" src="./assets/images/scenario/conclusion.svg"
                      /></span>
                      @if (settingsManager.settings.scenarioStats) {
                        <span (click)="statistics(scenarioData)" class="rewards stats" [ghs-tooltip]="'scenario.stats'"
                          ><img class="ghs-svg" src="./assets/images/stats.svg"
                        /></span>
                      }
                    }
                    @for (success of [] | ghsRange: countFinished(scenarioData); track success) {
                      <span>
                        <a
                          class="toggle-success"
                          [ghs-label]="'party.campaign.scenarios.removeSuccess'"
                          [ghs-label-attribute]="'title'"
                          (click)="removeSuccess(scenarioData)"
                          ><img class="success" src="./assets/images/check.svg" /><img class="remove" src="./assets/images/close.svg"
                        /></a>
                      </span>
                    }
                    @for (success of [] | ghsRange: countFinished(scenarioData, true); track success) {
                      <span>
                        <a
                          class="toggle-success casual"
                          [ghs-label]="'party.campaign.scenarios.removeSuccessCasual'"
                          [ghs-label-attribute]="'title'"
                          (click)="removeSuccess(scenarioData, true)"
                          ><img class="success" src="./assets/images/check.svg" /><img class="remove" src="./assets/images/close.svg"
                        /></a>
                      </span>
                    }
                    <a
                      class="add-success"
                      [ghs-label]="
                        scenarioData.isBlocked
                          ? 'scenario.blocked'
                          : scenarioData.isLocked
                            ? 'scenario.locked'
                            : 'party.campaign.scenarios.addSuccess'
                      "
                      [ghs-label-attribute]="'title'"
                      ghs-pointer-input
                      (singleClick)="addSuccess(scenarioData)"
                      (doubleClick)="addSuccess(scenarioData, true)"
                      [ngClass]="{ disabled: scenarioData.isBlocked || scenarioData.isLocked }"
                      ><img src="./assets/images/check.svg"
                    /></a>
                  </span>
                </div>
              }
              @if (scenarioEditions.length === 1) {
                <div class="scenario unlock">
                  <input
                    #unlockScenarioIndex
                    [ghs-label]="'party.campaign.scenarios.index'"
                    [ghs-label-attribute]="'placeholder'"
                    (keyup)="unlockScenarioIndex.classList.remove('error'); unlockScenarioGroup.classList.remove('error')"
                    (keyup.enter)="unlockScenario(unlockScenarioIndex, unlockScenarioGroup, edition)"
                  />
                  <input
                    #unlockScenarioGroup
                    [ghs-label]="'party.campaign.scenarios.group'"
                    [ghs-label-attribute]="'placeholder'"
                    (keyup)="unlockScenarioIndex.classList.remove('error'); unlockScenarioGroup.classList.remove('error')"
                    (keyup.enter)="unlockScenario(unlockScenarioIndex, unlockScenarioGroup, edition)"
                  />
                  <a
                    class="addScenario"
                    [ghs-label]="'party.campaign.scenarios.unlock'"
                    [ghs-label-attribute]="'title'"
                    (click)="unlockScenario(unlockScenarioIndex, unlockScenarioGroup, edition)"
                  >
                    <span [ghs-label]="'party.campaign.scenarios.unlock'"></span>&nbsp;<img src="./assets/images/plus.svg"
                  /></a>
                </div>
              }
            }
          </div>
          @if (manualConclusions) {
            <div
              class="row scenarios ignore-denied"
              [ngClass]="{ denied: gameManager.stateManager.permissions && !gameManager.stateManager.permissions.party }"
            >
              <div
                class="row scenarios ignore-denied"
                [ngClass]="{ denied: gameManager.stateManager.permissions && !gameManager.stateManager.permissions.party }"
              >
                @for (edition of scenarioEditions; track edition; let index = $index) {
                  @if (index > 0) {
                    <div class="scenario seperator"></div>
                  }
                  @if (scenarioEditions.length > 1) {
                    <div class="scenario header">
                      <span class="span"><span [ghs-label]="'data.edition.' + edition"></span></span>
                    </div>
                  }
                  @if (conclusions[edition] && conclusions[edition].length > 0) {
                    @if (index > 0) {
                      <div class="scenario seperator"></div>
                    }
                    <div class="scenario header">
                      <span class="span"><span [ghs-label]="'party.campaign.scenarios.conclusions'"></span></span>
                    </div>
                    @for (scenarioData of conclusions[edition] | trackUUID; track scenarioData._trackUUID) {
                      <div class="scenario">
                        <span>
                          #
                          @if (maxScenario(conclusions[edition]) > 2 && scenarioData.index.length < 3) {
                            <span>0</span>
                          }
                          @if (maxScenario(conclusions[edition]) > 1 && scenarioData.index.length < 2) {
                            <span>0</span>
                          }
                          {{ scenarioData.index }}
                        </span>
                        <span>
                          @if (scenarioData.group) {
                            <span [ghs-label]="'data.scenario.group.' + scenarioData.group"></span>
                          }
                        </span>
                        <span class="scenario-title">
                          @if (scenarioData.named) {
                            <span [ghs-label]="gameManager.scenarioManager.scenarioTitle(scenarioData, true)"></span>
                          }
                          @if (scenarioData.parent) {
                            <span [ghs-label]="'%data.scenarioNumber:' + scenarioData.parent + '%'"></span>
                          }
                        </span>
                        <span>
                          <span class="spacer"></span>
                          <span (click)="scenarioRewards(scenarioData, true)" class="rewards" [ghs-tooltip]="'scenario.summary.rewards'"
                            ><img class="ghs-svg" src="./assets/images/scenario/conclusion.svg"
                          /></span>
                          <a
                            class="toggle-success"
                            [ghs-label]="'party.campaign.scenarios.removeSuccess'"
                            [ghs-label-attribute]="'title'"
                            (click)="removeConclusion(scenarioData.index, edition)"
                            ><img class="success" src="./assets/images/check.svg" /><img class="remove" src="./assets/images/close.svg"
                          /></a>
                        </span>
                      </div>
                    }
                  }
                  @if (scenarioEditions.length === 1) {
                    <div class="scenario unlock">
                      <img class="ghs-svg" src="./assets/images/scenario/conclusion.svg" /> /
                      <img class="ghs-svg" src="./assets/images/puzzle.svg" />
                      <input
                        #unlockConclusionIndex
                        [ghs-label]="'party.campaign.scenarios.index'"
                        [ghs-label-attribute]="'placeholder'"
                        (keyup)="unlockConclusionIndex.classList.remove('error')"
                        (keyup.enter)="selectFinishConclusion(unlockConclusionIndex)"
                      />
                      <a
                        class="addScenario"
                        [ghs-label]="'party.campaign.scenarios.addConclusion'"
                        [ghs-label-attribute]="'title'"
                        (click)="selectFinishConclusion(unlockConclusionIndex)"
                      >
                        <span [ghs-label]="'party.campaign.scenarios.addConclusion'"></span>&nbsp;<img src="./assets/images/plus.svg"
                      /></a>
                    </div>
                  }
                }
              </div>
            </div>
          }
          @if (gameManager.fhRules() || gameManager.editionRules('gh')) {
            <div class="prosperity" [ngClass]="{ fh: fhSheet, wrapped: settingsManager.settings.wrapProsperity }">
              <div class="legend">
                <div class="level">
                  <span [ghs-label]="'party.prosperity'" [ghs-tooltip]="'party.prosperity.reset'" (click)="setProsperity(0)"></span>
                  @if (fhSheet) {
                    <img [ghs-tooltip]="'party.prosperity.reset'" src="./assets/images/fh/prosperity.svg" (click)="setProsperity(0)" />
                  }
                  <span>:</span>
                  <img
                    class="toggle-wrapped"
                    (click)="settingsManager.toggle('wrapProsperity')"
                    [ghs-tooltip]="'party.prosperity.wrap.' + (settingsManager.settings.wrapProsperity ? 'shrink' : 'expand')"
                    [src]="'./assets/images/' + (settingsManager.settings.wrapProsperity ? 'shrink' : 'expand') + '.svg'"
                  />
                </div>
                @if (!fhSheet) {
                  <div class="check" [ghs-tooltip]="'party.prosperity.reset'" (click)="setProsperity(0)">
                    <span class="checkbox checked disabled"></span><span>:</span>
                  </div>
                }
              </div>
              <div class="checklist">
                @for (check of [] | ghsRange: prosperitySteps[prosperitySteps.length - 1] + 1; track check; let index = $index) {
                  <div
                    class="tick"
                    [autoscroll]="gameManager.prosperityTicks() === index + 1 || (gameManager.prosperityTicks() === 0 && index === 0)"
                    [ngClass]="{ large: prosperitySteps.includes(index), section: prosperitySections[index] }"
                  >
                    @if (prosperitySteps.includes(index)) {
                      <div class="level" (click)="setProsperity(index + 1)">
                        {{ prosperitySteps.indexOf(index) + 2 }}
                      </div>
                    }
                    <div
                      class="checkbox"
                      (click)="setProsperity(index + 1)"
                      [ngClass]="{ checked: gameManager.prosperityTicks() > index, highlight: prosperityHighlightSteps.includes(index) }"
                    >
                      @if (prosperitySections[index]) {
                        <span class="section" [ghs-label]="'%game.section:' + prosperitySections[index] + '%'"></span>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (!fhSheet && gameManager.editionRules('gh')) {
            <div class="row donations">
              <label><span [ghs-label]="'party.campaign.donations'"></span>:</label>
              <div class="checklist">
                @for (check of [] | ghsRange: 10; track check) {
                  <div class="tick">
                    <div class="donation">
                      <div class="checkbox" (click)="setDonations(check + 1)" [ngClass]="{ checked: party.donations > check }"></div>
                      <img src="./assets/images/coin.png" />
                      <span class="value">+10g</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (!fhSheet && party.donations > 9 && gameManager.editionRules('gh')) {
            <div class="row envelope-b">
              <label (click)="toggleEnvelopeB()">
                <div class="checkbox" [ngClass]="{ checked: party.envelopeB }"></div>
                <span [ghs-label]="'party.campaign.envelopeB'"></span>
              </label>
              @if (party.envelopeB) {
                <div class="lines">
                  @for (line of [] | ghsRange: 5; track line) {
                    <div class="line">
                      @for (item of [] | ghsRange: 18; track item) {
                        <div class="item">
                          <span
                            class="checkpoint"
                            (click)="setDonations(10 + item + line * 18 + 1)"
                            [ngClass]="{
                              checked: party.donations > 10 + item + line * 18,
                              prosperity:
                                10 + item + line * 18 < 40 ? (10 + item + line * 18) % 5 === 4 : (10 + item + line * 18) % 10 === 9
                            }"
                          ></span>
                          <span class="value">{{ (11 + item + line * 18) * 10 }}</span>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
          <div class="row">
            @if (gameManager.editionRules('gh') || gameManager.gh2eRules()) {
              <div class="achievements">
                <label><span [ghs-label]="'party.campaign.achievements'"></span>:</label>
                <div class="achievements-container">
                  <div class="list">
                    @for (achievement of globalAchievementsList; track achievement; let i = $index) {
                      <div class="achievement">
                        @if (achievement.split(':').length > 0 && achievement.split(':')[1] !== '1') {
                          <span> {{ achievement.split(':')[1] }}x&nbsp; </span>
                        }
                        <span [ghs-label]="'data.globalAchievements.' + achievement.split(':')[0]"></span>
                        <span class="spacer"></span>
                        <span class="remove" (click)="removeGlobalAchievement(achievement)">
                          <img class="ghs-svg" src="./assets/images/close.svg"
                        /></span>
                      </div>
                    }
                  </div>
                  <div class="form">
                    <input
                      type="text"
                      #globalAchievementInput
                      [autocomplete]="globalAchievements"
                      [emptyLabel]="'party.addGlobalAchievement.empty'"
                      [ghs-label]="'party.addGlobalAchievement'"
                      [ghs-label-attribute]="'placeholder'"
                      (keyup.enter)="addGlobalAchievement(globalAchievementInput)"
                    />
                    <a
                      class="addScenario"
                      [ghs-label]="'party.addGlobalAchievement'"
                      [ghs-label-attribute]="'title'"
                      (click)="addGlobalAchievement(globalAchievementInput)"
                      ><img src="./assets/images/plus.svg"
                    /></a>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="row">
            <div class="items">
              <label><span [ghs-label]="'party.campaign.items'"></span>:</label>
              <div class="item-add">
                <input
                  min="1"
                  #itemIndex
                  type="number"
                  value=""
                  (focus)="itemIndex.select()"
                  (keyup)="itemIndex.classList.remove('error'); itemIndex.classList.remove('warning')"
                  (keyup.enter)="addItem(itemIndex, itemEdition || '')"
                />
                <a
                  [ngClass]="{
                    disabled: !itemEdition || !itemIndex.value || +itemIndex.value < 1 || hasItem(itemIndex.value, itemEdition)
                  }"
                  (click)="addItem(itemIndex, itemEdition || '')"
                  ><img src="./assets/images/plus.svg"
                /></a>
                <select [(ngModel)]="itemEdition" (change)="update()">
                  <option value="" [selected]="!itemEdition"><span [ghs-label]="'edition.all'"></span></option>
                  @for (edition of gameManager.editions(); track edition) {
                    <option [value]="edition" [selected]="edition === itemEdition">
                      <span [ghs-label]="'data.edition.' + edition"></span>
                    </option>
                  }
                </select>
              </div>
              <div class="item-list">
                @for (item of items | trackUUID; track item._trackUUID; let i = $index) {
                  <label class="item" [ngClass]="{ edition: !partyEdition || !itemEdition }">
                    @if (!!item) {
                      <span class="item-index open-item" (click)="openItem(item)">
                        <img class="icon" [src]="item.slot ? './assets/images/items/slots/' + item.slot + '.svg' : ''" />
                        <span class="index">{{ item.id }}</span>
                      </span>
                      <span class="separator">:</span>
                      <span class="checkbox" (click)="removeItem(item)"
                        ><img class="check" src="./assets/images/check.svg" /><img class="close" src="./assets/images/close.svg"
                      /></span>
                      <span
                        class="text open-item"
                        (click)="openItem(item)"
                        [ghs-label]="'data.items.' + item.edition + '-' + item.id"
                      ></span>
                      <span class="count" (click)="incItemCount(item, itemIdentifier[i])">
                        {{ itemIdentifier[i].count > 0 ? itemIdentifier[i].count : '-' }}
                      </span>
                      @if (!partyEdition || !itemEdition) {
                        <span class="text edition">[<span [ghs-label]="'data.edition.' + item.edition"></span>]</span>
                      }
                    }
                  </label>
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="treasures">
              <label class="treasures-title" (click)="treasuresDialog()">
                <img class="icon" src="./assets/images/scenario/treasure.svg" /><span [ghs-label]="'party.campaign.treasures'"></span
                >:</label
              >
              <div class="treasure-add">
                <input
                  min="1"
                  #treasureIndex
                  type="number"
                  value=""
                  (focus)="treasureIndex.select()"
                  (keyup)="treasureIndex.classList.remove('error'); treasureIndex.classList.remove('warning')"
                  (keyup.enter)="addTreasure(treasureIndex, treasureEdition)"
                />
                <a
                  [ngClass]="{
                    disabled:
                      !treasureEdition ||
                      !treasureIndex.value ||
                      +treasureIndex.value < 1 ||
                      hasTreasure(treasureIndex.value, treasureEdition)
                  }"
                  (click)="addTreasure(treasureIndex, treasureEdition)"
                  ><img src="./assets/images/plus.svg"
                /></a>
                <select [(ngModel)]="treasureEdition" (change)="update()">
                  <option value="" [selected]="!treasureEdition"><span [ghs-label]="'edition.all'"></span></option>
                  @for (edition of gameManager.editions(); track edition) {
                    <option [value]="edition" [selected]="edition === treasureEdition">
                      <span [ghs-label]="'data.edition.' + edition"></span>
                    </option>
                  }
                </select>
              </div>
              <div class="treasure-list">
                @for (treasure of treasures() | trackUUID; track treasure._trackUUID) {
                  <label class="treasure" [ngClass]="{ edition: !treasureEdition }">
                    <span class="treasure-index">
                      <img class="icon" src="./assets/images/scenario/treasure.svg" />
                      <span class="index">{{ treasure.name }}</span>
                    </span>
                    <span class="separator">:</span>
                    <span class="checkbox" (click)="removeTreasure(treasure)"
                      ><img class="check" src="./assets/images/check.svg" /><img class="close" src="./assets/images/close.svg"
                    /></span>
                    <span class="text">
                      <ghs-treasure-label [edition]="treasure.edition" [index]="+treasure.name - 1"></ghs-treasure-label>
                    </span>
                    <span></span>
                    @if (!treasureEdition) {
                      <span class="text">[<span [ghs-label]="'data.edition.' + treasure.edition"></span>]</span>
                    }
                  </label>
                }
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="row">
                <label><span [ghs-label]="'party.campaign.players'"></span>:</label>
              </div>
              <div class="row players">
                @for (index of [] | ghsRange: party.players.length; track index) {
                  <div class="player">
                    <span class="index">#{{ index + 1 }}</span>
                    <input type="text" [value]="party.players[index]" (change)="changePlayer($event, index)" />
                    @if (availableCharacters[index]) {
                      <div class="available-characters">
                        @for (characterModel of availableCharacters[index] | trackUUID; track characterModel._trackUUID) {
                          <a
                            class="available-character"
                            ghs-pointer-input
                            (singleClick)="openCharacterSheet(characterModel)"
                            (doubleClick)="replayCharacter(characterModel)"
                            [ghs-tooltip]="'character.replay.hint'"
                          >
                            <img [src]="gameManager.characterManager.characterIcon(characterModel.name, characterModel.edition)" />
                          </a>
                        }
                      </div>
                    }
                    <a class="remove" (click)="removePlayer(index)"><img src="./assets/images/close.svg" /></a>
                  </div>
                }
                <a class="add" (click)="party.players[party.players.length] = ''">
                  <img src="./assets/images/plus.svg" />
                  <span [ghs-label]="'party.campaign.players.add'"></span>
                </a>
              </div>
            </div>
            <div class="column">
              @if (settingsManager.settings.events) {
                <div class="row events">
                  <a (click)="setupEvents()">
                    <span [ghs-label]="'game.events.deck.setup'"></span>
                  </a>
                </div>
              }
              @if (settingsManager.settings.battleGoals) {
                <div class="row battle-goals">
                  <a (click)="battleGoalSetup()"><span [ghs-label]="'game.battleGoals.setup'"></span></a>
                </div>
              }
            </div>
          </div>
          @if (!!party.retirements && party.retirements.length > 0) {
            <div class="row">
              <label><span [ghs-label]="'party.campaign.retirements'"></span>:</label>
            </div>
          }
          @if (!!party.retirements && party.retirements.length > 0) {
            <div class="row retirements">
              <div class="list" [ngClass]="{ 'fh-sheet': fhSheet }">
                <div class="character header legend seperator">
                  <span><span [ghs-label]="'party.campaign.retirements.player'"></span></span>
                  <span><span [ghs-label]="'party.campaign.retirements.character'"></span></span>
                  <span><span [ghs-label]="'party.campaign.retirements.class'"></span></span>
                  <span><span [ghs-label]="'party.campaign.retirements.level'"></span></span>
                  <span><span [ghs-label]="'party.campaign.retirements.perks'"></span></span>
                  @if (fhSheet) {
                    <span><span [ghs-label]="'party.campaign.retirements.masteries'"></span></span>
                  }
                  <span></span>
                </div>
                @for (characterModel of party.retirements | trackUUID; track characterModel._trackUUID) {
                  <div class="character">
                    <span>
                      #<input
                        [value]="characterModel.number"
                        type="number"
                        min="1"
                        (change)="setPlayerNumber(characterModel, $event)"
                        (keyup)="setPlayerNumber(characterModel, $event)"
                      />
                    </span>
                    <span
                      class="link"
                      ghs-pointer-input
                      (singleClick)="openCharacterSheet(characterModel)"
                      (doubleClick)="openCharacterSheet(characterModel, false)"
                      >{{ characterModel.title }}</span
                    >
                    <span
                      class="link"
                      ghs-pointer-input
                      (singleClick)="openCharacterSheet(characterModel)"
                      (doubleClick)="openCharacterSheet(characterModel, false)"
                      [ghs-label]="'data.character.' + characterModel.edition + '.' + characterModel.name"
                    ></span>
                    <span>{{ characterModel.level }}</span>
                    <span>{{ characterPerks(characterModel) || '/' }}</span>
                    @if (fhSheet) {
                      <span>
                        @if (characterModel.progress) {
                          @for (mastery of characterModel.progress.masteries; track mastery) {
                            <span>
                              <img class="success" src="./assets/images/check.svg" />
                            </span>
                          }
                        }
                      </span>
                    }
                    <span
                      class="reactivate"
                      (click)="reactivateCharacter(characterModel)"
                      [ghs-label]="'party.campaign.retirements.reactivate'"
                      [ghs-label-attribute]="'title'"
                    >
                      <img class="ghs-svg" src="./assets/images/long-rest.svg" />
                    </span>
                  </div>
                }
              </div>
            </div>
          }
          <div class="row bottom-sheet">
            <span
              [ghs-label]="'party.campaign.totalTime'"
              [ghs-label-args]="[gameManager.game.totalSeconds | ghsDurationLabel: true]"
            ></span>
            <span class="spacer"></span>
            <a (click)="statistics()" [ghs-tooltip]="'scenario.stats'"><img class="ghs-svg" src="./assets/images/stats.svg" /></a>
          </div>
        </div>
      }
    </div>
  </div>
</div>
